import { DataSource, HorizontalSpacer, Layout, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPurgeControlList extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    panelHeaderEast: Panel;
    panelHeaderNorth: Panel;
    panelHeaderWest: Panel;
    panelSearch: Panel;
    searchpanelPurgeControl: SearchPanel;
    sourcePurgeControl: DataSource;
    switchHeaderIsEnabled: Switch;
    switchHeaderIsEnabledSecondaries: Switch;
    tablePurgeControl: Table;
    textboxHeaderGranularity: Textbox;
    textboxHeaderId: Textbox;
    textboxHeaderLastRun: Textbox;
    textboxHeaderPurgeClass: Textbox;
    textboxHeaderPurgeTime: Textbox;
}
